"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewEditPageResourcesSchema = exports.ReviewNewPageQuerySchema = exports.ReviewUpdateBodySchema = exports.ReviewUpdateResourcesSchema = exports.ReviewCreationBodySchema = exports.ReviewUpload = void 0;
var zod_1 = require("zod");
var constants_1 = require("./ui/review/constants");
/**
 * files 는 클라이언트 및 서버에서 form-data 처리방식이 상이하므로
 * 각 환경에서 확장하여 정의
 *
 * @see {@link https://github.com/colinhacks/zod/issues/387}
 */
exports.ReviewUpload = zod_1.z.object({
    rating: zod_1.z.string(),
    companion: zod_1.z.string(),
    keywords: zod_1.z.array(zod_1.z.string()).optional(),
    reviewComment: zod_1.z.preprocess(function (val) {
        if (typeof val === 'string') {
            return val.replace(/\r?\n|\r/g, '\n').trim();
        }
        return val;
    }, zod_1.z.string().min(10).max(1000)),
    photos: zod_1.z.array(zod_1.z.string()).max(constants_1.MAX_PHOTO_UPLOAD_COUNT).optional(),
    privateFeedbackComment: zod_1.z
        .preprocess(function (val) {
        if (typeof val === 'string') {
            return val.replace(/\r?\n|\r/g, '\n').trim();
        }
        return val;
    }, zod_1.z.string().max(1000))
        .optional(),
});
exports.ReviewCreationBodySchema = exports.ReviewUpload.extend({
    category: zod_1.z.union([zod_1.z.literal(constants_1.CATEGORY_KEYS.DOMESTIC), zod_1.z.literal(constants_1.CATEGORY_KEYS.LEISURE)]),
    orderId: zod_1.z.string(),
});
exports.ReviewUpdateResourcesSchema = zod_1.z.object({
    reviewId: zod_1.z.number(),
});
exports.ReviewUpdateBodySchema = exports.ReviewUpload;
exports.ReviewNewPageQuerySchema = zod_1.z.object({
    category: zod_1.z.union([zod_1.z.literal(constants_1.CATEGORY_KEYS.DOMESTIC), zod_1.z.literal(constants_1.CATEGORY_KEYS.LEISURE)]),
    orderId: zod_1.z.string(),
});
exports.ReviewEditPageResourcesSchema = zod_1.z.object({
    reviewId: zod_1.z.number(),
});
